export const LOADING_INVOICES = "LOADING_INVOICES";
export const GET_INVOICES_LIST = "GET_INVOICES_LIST";
export const GET_INVOICES_ID = "GET_INVOICES_ID";
export const REMOVE_INVOICES = "REMOVE_INVOICES";
export const ADD_INVOICES = "ADD_INVOICES";
export const UPDATE_INVOICES = "UPDATE_INVOICES";
export const RETURN_INVOICES = "RETURN_INVOICES";
export const LOADING_INVOICE_DOCUMENT = "LOADING_INVOICE_DOCUMENT";
export const GET_INVOICE_DOCUMENT_LIST = "GET_INVOICE_DOCUMENT_LIST";   
export const REMOVE_INVOICE_DOCUMENT = "REMOVE_INVOICE_DOCUMENT";